<template>
  <!-- 购地信息 -->
  <div>
    <block>
      <div id="landPurchaseCount" style="position: relative;height: 0;overflow: hidden;top: -120px;"></div>
      <div class="table-list-title dis-bet-cen">
        <div>购地信息 <span style="color: #5D6FE9;">{{page.total}}</span></div>
      </div>
      <el-table
        border
        :data="TableData"
        :cell-style="cellStyle"
        :header-cell-style="headerColor"
        style="width: 100%;">
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column
          prop="address"
          label="土地位置"
          width="300">
        </el-table-column>
        <el-table-column v-for="(item,index) in tableHeader" :key="index" :label="item.label" :property="item.property" align="center">
          <template #default="scope">
            <el-button v-if="scope.column.property == 'handleImg'">预览</el-button>
            <el-button v-else-if="scope.column.property == 'handleDetails'">详情</el-button>
            <span v-else>{{scope.row[scope.column.property] || '-'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="landHolderName"
          label="受让单位"
          width="250">
        </el-table-column>
        <el-table-column
          prop="signTime"
          label="签订日期"
          width="120">
        </el-table-column>
        <el-table-column
            label="操作"
            width="80">
            <template #default="scope">
             <el-button type="text" @click="handleTo(scope.row)">详情</el-button>
            </template>
          </el-table-column>
      </el-table>
      <div class="table-page">
        <el-pagination
          background
          hide-on-single-page="true"
          :page-size="10"
          :pager-count="7"
          layout="prev, pager, next"
          v-model:currentPage="page.pageNum"
          @current-change="pageChange"
          :total="page.total">
        </el-pagination>
      </div>
      <el-dialog title="购地信息详情" :append-to-body="appendtobody" v-model="dialogTableVisible">
        <div style="padding-bottom: 10px;">基本信息</div>
        <el-descriptions class="margin-top"  :column="2" :size="size" border>
          <el-descriptions-item :span="1">
            <template #label>行政区</template>
            {{companyDetail.adminArea || '-'}}
          </el-descriptions-item>
          <el-descriptions-item :span="1">
            <template #label>电子监管号</template>
            {{companyDetail.elecSuNum || '-'}}
          </el-descriptions-item>
          <el-descriptions-item :span="1">
            <template #label>项目名称</template>
            {{companyDetail.projectName || '-'}}
          </el-descriptions-item>
          <el-descriptions-item :span="1">
            <template #label>土地位置</template>
            {{companyDetail.projectLocation || '-'}}
          </el-descriptions-item>
          <el-descriptions-item :span="1">
            <template #label>面积（公顷）</template>
            {{companyDetail.area || '-'}}
          </el-descriptions-item>
          <el-descriptions-item :span="1">
            <template #label>土地来源</template>
            <div style="width: 150px;">{{companyDetail.landSource || '-'}}</div>
          </el-descriptions-item>
          <el-descriptions-item :span="1">
            <template #label>土地用途</template>
            <div style="width: 150px;">{{companyDetail.landUse || '-'}}</div>
          </el-descriptions-item>
          <el-descriptions-item :span="1">
            <template #label>供地方式</template>
            <div style="width: 150px;">{{companyDetail.landSupplyWay || '-'}}</div>
          </el-descriptions-item>
          <el-descriptions-item :span="1">
            <template #label>土地使用年限</template>
            <div style="width: 150px;">{{companyDetail.landUseYears || '-'}}</div>
          </el-descriptions-item>
          <el-descriptions-item :span="1">
            <template #label>行业分类</template>
            <div style="width: 150px;">{{companyDetail.industry || '-'}}</div>
          </el-descriptions-item>
          <el-descriptions-item :span="1">
            <template #label>土地级别</template>
            <div style="width: 150px;">{{companyDetail.landLevel || '-'}}</div>
          </el-descriptions-item>
          <el-descriptions-item :span="1">
            <template #label>成交价格（万元）</template>
            <div style="width: 150px;">{{companyDetail.transAmt || '-'}}</div>
          </el-descriptions-item>
          <el-descriptions-item :span="1">
            <template #label>土地使用权人</template>
            <div style="width: 150px;">{{companyDetail.landHolderName || '-'}}</div>
          </el-descriptions-item>
          <el-descriptions-item :span="1">
            <template #label>约定交地日期</template>
            <div style="width: 150px;">{{companyDetail.agreeLandTime || '-'}}</div>
          </el-descriptions-item>
          <el-descriptions-item :span="1">
            <template #label>约定开工日期</template>
            <div style="width: 150px;">{{companyDetail.agreeStartTime || '-'}}</div>
          </el-descriptions-item>
          <el-descriptions-item :span="1">
            <template #label>约定竣工日期</template>
            <div style="width: 150px;">{{companyDetail.agreeEndTime || '-'}}</div>
          </el-descriptions-item>
          <!-- <el-descriptions-item :span="1">
            <template #label>实际开工日期</template>
            <div style="width: 150px;">{{companyDetail.actualStartTime || '-'}}</div>
          </el-descriptions-item> -->
          <!-- <el-descriptions-item :span="1">
            <template #label>实际竣工日期</template>
            <div style="width: 150px;">{{companyDetail.actualEndTime || '-'}}</div>
          </el-descriptions-item> -->
          <el-descriptions-item :span="1">
            <template #label>批准单位</template>
            <div style="width: 150px;">{{companyDetail.approvalUnit || '-'}}</div>
          </el-descriptions-item>
          <el-descriptions-item :span="1">
            <template #label>合同签订日期</template>
            <div style="width: 150px;">{{companyDetail.signTime || '-'}}</div>
          </el-descriptions-item>
        </el-descriptions>
        <div style="height: 40px;line-height: 40px;">分期支付约定</div>
        <el-descriptions class="margin-top"  :column="2" :size="size" border>
          <el-descriptions-item :span="1">
            <template #label>支付期号</template>
            <div style="width: 150px;">{{companyDetail.paymentRound || '-'}}</div>
          </el-descriptions-item>
          <el-descriptions-item :span="1">
            <template #label>约定支付日期</template>
            <div style="width: 150px;">{{companyDetail.agreePayDate || '-'}}</div>
          </el-descriptions-item>
          <el-descriptions-item :span="1">
            <template #label>约定支付金额（万元）</template>
            <div style="width: 150px;">{{companyDetail.agreePayAmt || '-'}}</div>
          </el-descriptions-item>
          <el-descriptions-item :span="1">
            <template #label>备注</template>
            <div style="width: 150px;">{{companyDetail.mark || '-'}}</div>
          </el-descriptions-item>
        </el-descriptions>
        <div style="height: 40px;line-height: 40px;">约定容积率</div>
        <el-descriptions class="margin-top"  :column="2" :size="size" border>
          <el-descriptions-item :span="1">
            <template #label>下限</template>
            <div style="width: 150px;">{{companyDetail.agreeRateMin || '-'}}</div>
          </el-descriptions-item>
          <el-descriptions-item :span="1">
            <template #label>上限</template>
            <div style="width: 150px;">{{companyDetail.agreeRateMax || '-'}}</div>
          </el-descriptions-item>
        </el-descriptions>
      </el-dialog>
    </block>
  </div>
</template>

<script>
import { forwardBG } from '@/api/forward.js'
export default {
  name: 'land-publish-count',
  props: { companyId: String },
  data () {
    return {
      appendtobody: true,
      companyDetail: {},
      dialogTableVisible: false,
      page: {
        total: 0,
        pageNum: 1
      },
      // 股东信息
      tableHeader: [{
        label: '土地面积（公顷）',
        property: 'area'
      }, {
        label: '成交价格（万元）',
        property: 'transAmt'
      }, {
        label: '土地用途',
        property: 'landUse'
      }],
      TableData: []
    }
  },
  mounted () {
    this.initData()
  },
  methods: {
    handleTo (e) {
      this.dialogTableVisible = true
      const vm = this
      const data = {
        dateBackgroundUrl: '/LandPurchase/getLandPurchaseDetail',
        dateBackgroundRequestType: 'get',
        data: {
          lpId: e.lpId
        }
      }
      forwardBG(data).then(result => {
        if (result.code === 0) {
          const res = result.data
          if (result.data) {
            res.agreePayDate = res.agreePayDate ? res.agreePayDate.substring(0, 10) : '-'
            res.signTime = res.signTime ? res.signTime.substring(0, 10) : '-'
            res.actualStartTime = res.actualStartTime ? res.actualStartTime.substring(0, 10) : '-'
            res.agreeLandTime = res.agreeLandTime ? res.agreeLandTime.substring(0, 10) : '-'
            res.agreeEndTime = res.agreeEndTime ? res.agreeEndTime.substring(0, 10) : '-'
            res.agreeStartTime = res.agreeStartTime ? res.agreeStartTime.substring(0, 10) : '-'
            vm.companyDetail = res
          } else {
            vm.companyDetail = {}
          }
        }
      }).catch(error => {
        console.log(error)
      })
    },
    // 表格设置样式
    headerColor: function ({ row, column, rowIndex, columnIndex }) {
      return 'background-color:#E8EBFC;color:#666666;font-size:14px;text-align:center'
    },
    cellStyle: function ({ row, column, rowIndex, columnIndex }) {
      return 'text-align:center'
    },
    pageChange (e) {
      this.page.pageNum = e
      this.initData()
    },
    initData: function () {
      const vm = this
      const data = {
        dateBackgroundUrl: '/LandPurchase/getLandPurchaseDetailList',
        dateBackgroundRequestType: 'get',
        data: {
          qccCompanyId: vm.companyId,
          pageNum: vm.page.pageNum,
          pageSize: 10
        }
      }
      forwardBG(data).then(result => {
        if (result.code === 0) {
          const res = result.data
          const arr = []
          vm.page.total = res.total
          res.list.forEach(item => {
            item.signTime = item.signTime ? item.signTime.substring(0, 10) : '-'
            arr.push(item)
          })
          vm.TableData = arr
        }
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>

<style scoped="scoped" lang="less">
.table-list-title {
  padding: 18px 0;
  text-align: left;
  color: #333;
  font-weight: bold;
}
.table-page {
  text-align: right;
  margin-top: 10px;
}
</style>
